export default __webpack_public_path__ + "static/media/client22.d405882f.png";